import React, {component} from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './toolbar.scss';


class ToolBar extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          hover:{
              "back":false,
              "grid":false,
              "list":false,
          },
          flow:{
            "frontpage":"frontpage",
            "legalpage":"frontpage",
            "gridviewpage":"frontpage",
            "listpage":"frontpage",
            "detailpage":"gridviewpage",
            "shoppingcart":"gridviewpage",
            
          }
        }
    }

componentDidMount(){
    var onswitch = this.state.hover
    if (this.props.viewOption === "grid"){
        onswitch["grid"] = true
    }
    else if (this.props.viewOption === "list"){
        onswitch["list"] = true
    }
    // alert(JSON.stringify(onswitch))
    this.setState({hover:onswitch})
}


  render(){

    return (
      <div className="toolbar-main">
          
        <div className={"back-wrapper"}  
            onMouseEnter={(e)=>{
                var _bool = this.state.hover
                _bool["back"] = true
                this.setState({hover:_bool})
            }}
            onMouseLeave={(e)=>{
                var _bool = this.state.hover
                _bool["back"] = false
                this.setState({hover:_bool})
            }}
            onClick={(e)=>{
                var past = this.state.flow[this.props.previousView]
                this.props.setval({currentPage:this.props.previousView,previousView:past})
            }}>
            <div className={"icon-wrapper"} >
                <img className={(this.state.hover["back"])?"fill-bright":"fill-normal"} src={"/assets/arrow-left.svg"} width="30px" height="30px" />
            </div>
            <div className={"back-text"}>
            &nbsp;&nbsp;&nbsp;{"BACK"}
            </div>
        </div>

        {((this.props.currentPage === "gridviewpage") || 
        (this.props.currentPage === "listpage")) && 
        <div className={"back-wrapper"}>
            <div id={"grid-icon"} className={"icon-wrapper"}
            onMouseEnter={(e)=>{
                var _bool = this.state.hover
                _bool["grid"] = true
                this.setState({hover:_bool})
            }}
            onMouseLeave={(e)=>{
                var _bool = this.state.hover
                if(this.props.viewOption !== "grid"){
                _bool["grid"] = false
                }
                this.setState({hover:_bool})
            }}
            onClick={(e)=>{
                var bool_a = this.state.hover
                bool_a["list"] = false
                this.props.setval({
                    viewOption:"grid",
                    currentPage:"gridviewpage"
                })
                this.setState({hover:bool_a})
            }}>
                <img className={(this.state.hover["grid"])?"fill-bright":"fill-normal"} src={"/assets/gridview.svg"} width="30px" height="30px" />
            </div>
            <div id={"list-icon"} className={"icon-wrapper"}
            onMouseEnter={(e)=>{
                var _bool = this.state.hover
                _bool["list"] = true
                this.setState({hover:_bool})
            }}
            onMouseLeave={(e)=>{
                var _bool = this.state.hover
                if(this.props.viewOption !== "list"){
                _bool["list"] = false
                }
                this.setState({hover:_bool})
            }}
            onClick={(e)=>{
                var bool_a = this.state.hover
                bool_a["grid"] = false
                this.props.setval({
                    viewOption:"list",
                    currentPage:"listpage"
                })
                this.setState({hover:bool_a})
            }}>
                <img className={(this.state.hover["list"])?"fill-bright":"fill-normal"} src={"/assets/listview.svg"} width="30px" height="30px" />
            </div>
        </div>
    }

      </div>
    );


  }
}

export default ToolBar;
